ScoreTrekBattle.Information = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            active: false,
            $view: null
        };
    }
    resetStatus();

    function onViewRender(viewId) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu(`/${viewId}`);
            ScoreTrekBattle.Template.render(`information/${viewId}`).then(view => {
                STATUS.active = true;
                STATUS.$view = view.$view;
                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function renderPlayerRating(rating, $container) {
        let ratingPromises = [];

        rating.forEach(ratingItem => {
            ratingPromises.push(ScoreTrekBattle.Template.render('tournament/details/playerRating', {rating: ratingItem}));
        });

        Promise.all(ratingPromises).then(ratingViews => {
            ratingViews.forEach(ratingView => {
                $container.append(ratingView.$view);
            });
        }).catch(error => {
            console.error(error);
            $container.append(`<span class="text-red">${__i18n(`error/somethingWentWrong`)}</span>`);
        });
    }

    function renderPlayerTournaments(tournaments, $container) {
        let tournamentPromises, currentTournament, currentSeries;
        
        tournamentPromises = [];

        currentTournament = ScoreTrekBattle.Tournament.getCurrent();
        currentSeries = ScoreTrekBattle.Series.getCurrent();

        tournaments.forEach(tournament => {
            let isSameTournament, isSameSeries, isForeign;

            isSameTournament = !!(currentTournament && (currentTournament.id === tournament.tournament.id));
            isSameSeries = !!((currentTournament && currentTournament.seriesId && (currentTournament.seriesId === tournament.tournament.seriesId)) || (currentSeries && (currentSeries.id === tournament.tournament.seriesId)));
            isNext = !!(currentTournament && currentTournament.nextTournamentId && ((currentTournament.nextTournamentId === tournament.tournament.id) || (currentTournament.id === tournament.tournament.nextTournamentId)));

            isForeign = !isSameTournament && !isSameSeries && !isNext;

            tournamentPromises.push(renderPlayerTournament(tournament.tournament, getTournamentPositionHtml(tournament.position), getTournamentScoreHtml(tournament.score), isForeign));
        });

        Promise.all(tournamentPromises).then($tournaments => {
            $tournaments.forEach($tournament => {
                $container.append($tournament);
            });
        }).catch(error => {
            console.error(error);
            $container.append(`<span class="text-red">${__i18n(`error/somethingWentWrong`)}</span>`);
        });
    }

    function renderPlayerTournament(tournament, positionHtml, scoreHtml, isForeign) {
        return new Promise(resolve => {
            ScoreTrekBattle.Tournament.renderTournamentItem(tournament, '', 0, isForeign).then($tournament => {;
                if (!tournament.id) {
                    $tournament.find('[data-id="tournamentItem"]').toggleClass('isRestricted').attr('href', 'javascript:');
                }
                $tournament.find('[data-id="tournamentItem"]').attr('data-event-is-public', tournament.isPublic ? 'yes' : 'no');
                resolve(
                    $('<div>').addClass('player-tournaments-item').append(
                        $('<span>').addClass('player-tournaments-item-position row-center row-between mt-small text-no-wrap').append(
                            positionHtml
                        ),
                        $('<span>').addClass('player-tournaments-item-score row-center row-end mt-small text-no-wrap').attr({
                            'data-info-popup': 'pointsMap/info/points'
                        }).on('click', ScoreTrekBattle.Template.handleInfoPopupClick).append(
                            scoreHtml
                        ),
                        $tournament.addClass('player-tournaments-item-tournament')
                    )
                );
            });
        });
    }

    function renderPrevTournament(prevTournament, positionHtml, $container) {
        ScoreTrekBattle.Tournament.renderTournamentItem(prevTournament, '<i class="fa-solid fa-diagram-project"></i>').then($prevTournament => {;
            $container.append(
                $('<span>').addClass('text-no-wrap text-large').append(
                    positionHtml
                ),
                $prevTournament
            );
        });
    }

    function renderParticipantDetails(participant, hasPrevTournament, showContactLink) {
        let details, isDeleted, tournament;

        details = [];
        isDeleted = participant.player.deleted;

        details.push([`<div class="player mb-large isLarge${participant.player.pro_account ? ' isProPlayer' : ''}">`,
            `<span class="player-avatar" style="background-image:url('${participant.player.avatar}');"></span>`,
            `<span class="player-name-wrapper">`,
                `<span class="player-name row-center${isDeleted ? ' text-red text-italic' : ''}">`,
                    `${isDeleted ? participant.fullName : participant.player.name}`,
                `</span>`,
            `</span>`,
            `${participant.player.verified ? '' : '<span class="badge bg-color-pink color-white ml-small" data-info-popup="player/info/notVerified"><i class="fa-solid fa-triangle-exclamation"></i></span>'}`,
            `${participant.player.custom ? '<span class="badge bg-color-white color-pink ml-small" data-info-popup="player/info/custom"><i class="fa-solid fa-user-slash"></i></span>' : ''}`,
        `</div>`].join(''));

        details.push([`<div class="player" style="justify-content:center;">`,
            `<span class="player-avatar" style="background-image:url('${participant.player.club ? participant.player.club.thumbnail : ScoreTrekBattle.ASSETS.PLACEHOLDER.club}');"></span>`,
            `<span class="player-name-wrapper">`,
                `<span class="player-name row-center">`,
                    `<span>`,
                        `${participant.player.club ? __escapeHTML(participant.player.club.official_name) : `<i>${__i18n('player/noClubAssigned')}</i>`}`,
                        `${participant.player.club ? `<br><span class="color-white-50 inline-block mt-tiny">${__escapeHTML(participant.player.club.zip)} ${__escapeHTML(participant.player.club.city)}</span>` : ''}`,
                    `</span>`,
                `</span>`,
            `</span>`,
        `</div>`].join(''));

        if (participant.playerId) {
            details.push([`<div class="copyable player-id-row mt-small text-smaller" data-show-access-level="sys_admin" data-trigger-action="copy" title="${__i18n('button/copy')}">`,
                `<span class="color-blue">`,
                    `<i class="fa-solid fa-clipboard-user"></i>`,
                `</span>`,
                `<span class="color-yellow copyable-text">`,
                    __escapeHTML(participant.playerId),
                `</span>`,
            `</div>`].join(''));

            details.push([`<div class="player-login-row mt-small text-center show-admin-mode hide-app">`,
                `<span class="button button-small button-secondary" data-trigger-action="player.loginAs" data-player-id="${participant.playerId}">`,
                    `<i class="fa-solid fa-lock-open"></i>`,
                    `<span>${__i18n('button/login')}</span>`,
                    `<i class="fa-solid fa-angle-right"></i>`,
                `</span>`,
            `</div>`].join(''));
        }

        tournament = ScoreTrekBattle.Tournament.getCurrent();

        if (showContactLink && tournament) {
            details.push([`<div class="mt-medium mb-medium show-battle-manager" data-show-for-club="${tournament.clubId}" data-participant-id="${participant.id}">`,
                `<a href="javascript:" data-trigger-action="participant.contact:close" class="color-blue">`,
                    `<span><i class="fa-regular fa-envelope"></i> ${__i18n('action/contact')}</span>`,
                    `<span class="text-smaller ml-tiny"><i class="fa-solid fa-chevron-right"></i></span>`,
                `</a>`,
            `</div>`].join(''));
        }

        if (participant.status === 'requested') {
            details.push([`<div class="bg-color-white-20 rounded-semi pl-medium pr-large py-small mt-medium row row-center">`,
                `<span class="color-light-pink"><i class="fa-solid fa-user-tag"></i></span>`,
                `<span class="color-white-75 text-smaller">${__i18n('player/info/requested')}</span>`,
            `</div>`].join(''));
        }

        if (participant.dateTimeRequest) {
            details.push([`<div>`,
                `<h4 class="text-white mt-medium mb-small">${__i18n(hasPrevTournament ? 'player/qualifiedAt' : 'player/requestedAt')}</h4>`,
                `<div class="row-center">`,
                    `<span class="color-green mr-tiny"><i class="fa-solid fa-calendar-plus"></i></span>`,
                    `<span class="color-green">${participant.dateTimeRequest}</span>`,
                `</div>`,
            `</div>`].join(''));
        }

        return details;
    }

    function showParticipantDialog(title, details, buttons) {
        let $details;

        $details = $(details.join(''));
        $details.find('[data-info-popup]').on('click', ScoreTrekBattle.Template.handleInfoPopupClick);

        if (!Array.isArray(buttons)) {
            buttons = [];
        }

        buttons.push({
            label: __i18n('button/close'),
            primary: false,
            action: () => {}
        });

        chmDialog({
            title: title,
            content: $details,
            buttons: buttons,
            large: true,
            isPersistant: true
        });

        return $details;
    }

    function getPrevTournamentPositionHtml(participant) {
        let hasGroup;

        hasGroup = (participant.prevTournamentGroupNumber > 0);

        return [
            hasGroup ? `<span class="text-smaller">${__i18n('game/groupShort', {group: participant.prevTournamentGroupNumber})}:</span>` : '<i class="fa-solid fa-medal"></i>',
            `<span class="color-blue text-bold ml-tiny">`,
                `${participant.prevTournamentPosition}.`,
            `</span>`
        ].join('');
    }

    function getTournamentPositionHtml(position) {
        return [
            getTournamentPositionIconHtml(position),
            `<span class="color-white text-bold ml-tiny">`,
                `${position}.`,
            `</span>`
        ].join('');
    }

    function getTournamentPositionIconHtml(position) {
        let icon, color;

        icon = (position <= 3) ? '<i class="fa-solid fa-trophy"></i>' : '<i class="fa-solid fa-medal"></i>';

        if (position === 1) {
            color = 'gold';
        } else if (position === 2) {
            color = 'silver';
        } else if (position === 3) {
            color = 'bronze';
        } else {
            color = 'white-30';
        }

        return `<i class="color-${color}">${icon}</i>`;
    }

    function getTournamentScoreHtml(score) {
        return `<span class="color-white-50 mr-tiny"><i class="fa-solid fa-chart-pie-simple"></i></span><span class="color-green mr-tiny">${score}</span>`;
    }

    function renderInfoMoreContent(infoType, $infoMore) {
        return new Promise((resolve, reject) => {
            if (!$infoMore.hasClass('isLoading')) {
                reject();
                return;
            }

            if (infoType === 'rating') {
                renderInforMoreContentRating($infoMore).then(resolve);
            } else if (infoType === 'tournaments') {
                renderInforMoreContentTournaments($infoMore).then(resolve);
            } else if (infoType === 'matches') {
                renderInforMoreContentMatches($infoMore).then(resolve);
            } else if (infoType === 'opponents') {
                renderInforMoreContentOpponents($infoMore).then(resolve);
            } else {
                resolve();
            }
        });
    }

    function enforceOwnStatsPublic(showDialog) {
        return new Promise((resolve, reject) => {
            let sessionPlayer = ScoreTrekBattle.Session.getPlayer();

            if (sessionPlayer && sessionPlayer.privacy_stats_public) {
                return resolve();
            }

            if (!showDialog) {
                return reject();
            }

            chmDialog({
                title: __i18n('dialog/statsLocked/title'),
                content: __i18n('dialog/statsLocked/text'),
                buttons: [
                    {
                        label: `<i class="fa-solid fa-lock-open"></i> <span>${__i18n('button/unlock')}</span>`,
                        primary: true,
                        action: function() {
                            Api.request('/battle/player/unlockStats').then(result => {
                                if (result && result.changed) {
                                    if (sessionPlayer) {
                                        sessionPlayer.privacy_stats_public = true;
                                    }
                                    resolve();
                                } else {
                                    reject();
                                }
                            }).catch(error => {
                                console.error(error);
                                reject(error);
                            });
                        }
                    },
                    {
                        label: __i18n('button/cancel'),
                        action: function() {
                            reject();
                        }
                    }
                ]
            });
        });
    }

    function renderInforMoreContentMatches($infoMore) {
        let $matches = $infoMore.find('[data-id="playerMatches"]');
        let playerId = $matches.attr('data-player-id');

        if (!playerId) {
            return Promise.resolve().then(() => {
                $matches.removeClass('loading').empty().append(renderNotLinkedNotice());
            });
        }

        return loadStatsWithPrivacy($matches, '/battle/player/games', {
            playerID: playerId,
            limit: 50,
            offset: 0
        }, function(response) {
            if (response.games && (response.games.length > 0)) {
                renderMatchesList(response, $matches);
            } else {
                $matches.append(renderEmptyNotice('player/matches/none'));
            }
        });
    }

    function renderInforMoreContentOpponents($infoMore) {
        let $opponents = $infoMore.find('[data-id="playerOpponents"]');
        let playerId = $opponents.attr('data-player-id');

        if (!playerId) {
            return Promise.resolve().then(() => {
                $opponents.removeClass('loading').empty().append(renderNotLinkedNotice());
            });
        }

        return loadStatsWithPrivacy($opponents, '/battle/player/opponents', {
            playerID: playerId,
            useBattle: true
        }, function(response) {
            if (response.opponents && (response.opponents.length > 0)) {
                renderOpponentsList(response.opponents, $opponents);
            } else {
                $opponents.empty().append(
                    renderOpponentsNotice(),
                    renderEmptyNotice('player/opponents/none')
                );
            }
        });
    }

    function renderNotLinkedNotice() {
        return $(`<div class="text-white-50 pt-small"><i class="fa-solid fa-user-slash"></i> ${__i18n('player/notLinked')}</div>`);
    }

    function renderOpponentsNotice() {
        return $([
            `<div class="py-small">`,
                `<div class="bg-color-darker-yellow p-small rounded row-center">`,
                    `<span class="color-blue mr-small">`,
                        `<i class="fa-solid fa-info-circle"></i>`,
                    `</span>`,
                    `<span class="color-white-70 text-smaller">`,
                        __i18n('player/opponents/notice'),
                    `</span>`,
                `</div>`,
            `</div>`
        ].join(''));
    }

    function loadStatsWithPrivacy($container, endpoint, post, onSuccess) {
        return new Promise(resolve => {
            function load() {
                $container.empty().addClass('loading');
                Api.request(endpoint, post).then(response => {
                    $container.empty();
                    if (!response) {
                        $container.append(renderErrorNotice('somethingWentWrong'));
                    } else if (response.isDisabled) {
                        //fallback: server rejected even though the client-side
                        //pre-check passed (e.g. stale session). Render an inline
                        //notice with a retry button.
                        $container.append(renderOwnPrivacyNotice(load));
                    } else if (response.statsDisabled) {
                        $container.append(renderTargetPrivacyNotice());
                    } else {
                        onSuccess(response);
                    }
                }).catch(error => {
                    $container.empty();
                    $container.append(renderErrorNotice(error && error.message));
                    console.error(error);
                }).finally(() => {
                    $container.removeClass('loading');
                    resolve();
                });
            }

            load();
        });
    }

    function renderEmptyNotice(key) {
        return $(`<div class="text-white-50 pt-small"><i class="fa-solid fa-inbox"></i> ${__i18n(key)}</div>`);
    }

    function renderErrorNotice(messageKey) {
        let text = messageKey ? __i18n(`error/${messageKey}`) : __i18n('error/somethingWentWrong');
        return $(`<div class="text-red pt-small">${text}</div>`);
    }

    function renderTargetPrivacyNotice() {
        return $(`<div class="text-white-50 pt-small"><i class="fa-solid fa-user-shield"></i> ${__i18n('player/stats/targetPrivate')}</div>`);
    }

    function renderOwnPrivacyNotice(reload) {
        let $notice = $([
            `<div class="pt-small">`,
                `<div class="color-white-50">`,
                    __i18n('player/stats/ownPrivate'),
                `</div>`,
                `<div class="mt-small">`,
                    `<div class="button button-secondary button-small" data-id="unlock">`,
                        `<i class="fa-solid fa-lock-open"></i>`,
                        `<span>${__i18n('button/unlock')}</span>`,
                    `</div>`,
                `</div>`,
            `</div>`
        ].join(''));

        $notice.find('[data-id="unlock"]').on('click', function() {
            enforceOwnStatsPublic(true).then(reload).catch(ignore => {});
        });

        return $notice;
    }

    function renderMatchesList(data, $container) {
        let lastDate = '';
        let opponentsMap = data.opponents || {};
        let selfPlayerId = (data.player && data.player.id) || '';
        let $list = $('<div>').addClass('player-matches-list');

        data.games.forEach(item => {
            let game = item.game || {};
            let opp = item.opponent || {};
            let player = item.player || {};
            let isBattle = (game.source === 'battle');
            let won = (opp.result < player.result);
            let tie = (opp.result === player.result);

            //game.date may include the time (e.g. "13.03.2026 14:30:00") when
            //APP_BUILD is not sent along — use the first segment only for
            //grouping and date comparison.
            let rawDate = String(game.date || '').split(' ')[0];
            let displayDate = rawDate;

            if (data.date) {
                if (rawDate === data.date.today)          { displayDate = __i18n('player/matches/today'); }
                else if (rawDate === data.date.yesterday) { displayDate = __i18n('player/matches/yesterday'); }
            }

            if (rawDate !== lastDate) {
                $list.append($('<div>').addClass('player-matches-date').text(displayDate));
                lastDate = rawDate;
            }

            let oppRaw = opponentsMap[opp.id];
            let ownRaw = game.own_team_id ? opponentsMap[game.own_team_id] : null;

            let oppPlayers = (isBattle && oppRaw && oppRaw.players)
                ? oppRaw.players.filter(p => !!p)
                : [];
            let ownPlayers = (isBattle && ownRaw && ownRaw.players)
                ? ownRaw.players.filter(p => !!p && p.playerId !== selfPlayerId)
                : [];

            let isDoubleOpp = (oppPlayers.length > 1);
            let oppName = '';
            let oppAvatar = '';
            let oppIsPro = false;

            if (isBattle && oppRaw) {
                if (oppPlayers.length === 1) {
                    oppName = oppPlayers[0].name || oppRaw.name || '';
                    oppAvatar = oppPlayers[0].avatar || '';
                    oppIsPro = !!oppPlayers[0].pro_account;
                } else {
                    oppName = oppRaw.name || '';
                }
            } else if (oppRaw) {
                oppName = oppRaw.name || '';
                oppAvatar = oppRaw.avatar || '';
                oppIsPro = !!oppRaw.pro_account;
            }

            let $match = $('<div>').addClass('player-matches-match')
                .attr('data-won', won ? 'yes' : (tie ? 'tie' : 'no'))
                .attr('data-is-double', isDoubleOpp ? 'yes' : 'no');

            let $opponent = $('<span>').addClass('player-matches-match-opponent');
            if (oppIsPro && !isDoubleOpp) { $opponent.addClass('isProPlayer'); }

            if (isDoubleOpp) {
                $opponent.addClass('isTeam').append(
                    oppPlayers.map(p => renderTeamPlayerChip(p))
                );
            } else {
                $opponent.append(
                    $('<span>').addClass('player-matches-match-opponent-name').text(oppName),
                    $('<span>').addClass('player-matches-match-opponent-avatar').css('background-image', `url('${oppAvatar}')`)
                );
            }

            $match.append(
                renderGameTypeLabel(game.type, game.subType, isBattle),
                $('<span>').addClass('player-matches-match-result').append(
                    renderHandicap(player.handicap),
                    $('<span>').addClass('player-matches-match-result-player').text(player.result),
                    $('<span>').addClass('player-matches-match-result-separator').text(':'),
                    $('<span>').addClass('player-matches-match-result-opponent').text(opp.result),
                    renderHandicap(opp.handicap)
                ),
                $opponent,
                $('<span>').addClass('player-matches-match-time').text(game.time || '')
            );

            if (ownPlayers.length > 0) {
                $match.append(
                    $('<span>').addClass('player-matches-match-own-team').append(
                        ownPlayers.map(p => renderTeamPlayerChip(p, true))
                    )
                );
            }

            $list.append($match);
        });

        $container.append($list);
    }

    function renderHandicap(handicap) {
        handicap = parseInt(handicap, 10) || 0;

        if (handicap === 0) {
            return null;
        }

        return $('<span>').addClass('player-matches-match-result-handicap').text(`+${handicap}`);
    }

    function renderTeamPlayerChip(p, isOwn) {
        let $chip = $('<span>').addClass('player-matches-match-team-player');
        if (isOwn)                 { $chip.addClass('isOwn'); }
        if (p && p.pro_account)    { $chip.addClass('isProPlayer'); }
        $chip.append(
            $('<span>').addClass('player-matches-match-team-player-avatar').css('background-image', `url('${p && p.avatar || ''}')`),
            $('<span>').addClass('player-matches-match-team-player-name').text((p && p.name) || '')
        );
        return $chip;
    }

    function renderGameTypeLabel(gameType, subType, isBattle) {
        let type = gameType || '';
        let i18nKey = `gameType/${type}`;
        let iconUrl = type ? `/res/img/game/${type}.svg` : '';
        let label = __i18n(i18nKey);

        //fall back to the raw key if no translation exists
        if (!label || (label === i18nKey)) {
            label = type;
        }

        if (subType) {
            let subKey = `gameTypeSub/${type}/${subType}`;
            let subLabel = __i18n(subKey);
            if (subLabel && (subLabel !== subKey)) {
                label = `${label} · ${subLabel}`;
            }
        }

        return $('<span>').addClass('player-matches-match-type').append(
            iconUrl
                ? $('<span>').addClass('player-matches-match-type-icon').css('background-image', `url('${iconUrl}')`)
                : null,
            $('<span>').addClass('player-matches-match-type-label').text(label),
            isBattle
                ? $('<span>').addClass('player-matches-match-type-battle').css('background-image', `url('/res/img/game/battle.svg')`)
                : null
        );
    }

    function renderOpponentsList(opponents, $container) {
        opponents.sort((a, b) => String(a.opponent.name || '').toLowerCase().localeCompare(String(b.opponent.name || '').toLowerCase()));

        let $list = $('<div>').addClass('player-opponents-list');
        opponents.forEach(entry => {
            let opp = entry.opponent;
            let stats = entry.stats || {};
            let allStats = stats.all || {quote: 0, total: 0};
            let quote = (allStats.quote || 0) * 100;
            //always show the quote (the backend preserves the computed quote even
            //when it zeros total/won/lost/tie for privacy-private opponents).
            let quoteText = `${quote.toFixed(2).replace('.', ',')}%`;
            let isCustom = !!opp.custom;

            let $avatar = $('<span>').addClass('player-opponents-item-avatar')
                .css('background-image', `url('${opp.thumbnail || opp.avatar || ''}')`);

            let $item = $('<div>').addClass('player-opponents-item')
                .attr('data-player-id', opp.id || '')
                .attr('data-is-custom', isCustom ? 'yes' : 'no')
                .append(
                    $avatar,
                    $('<span>').addClass('player-opponents-item-name').text(opp.name || ''),
                    $('<span>').addClass('player-opponents-item-quote').text(quoteText),
                    opp.id ? $('<span>').addClass('player-opponents-item-link').html('<i class="fa-solid fa-arrow-up-right-from-square"></i>').on('click', function() {
                        chmDialog.close();

                        ScoreTrekBattle.Information.showParticipantInfo({
                            id: null,
                            playerId: opp.id,
                            player: opp
                        });
                    }) : null
                );
            if (opp.pro_account) { $item.addClass('isProPlayer'); }
            $list.append($item);
        });

        $container.empty().append(
            renderOpponentsNotice(),
            $list
        );
    }

    function renderInforMoreContentRating($infoMore) {
        return new Promise(resolve => {
            let $rating = $infoMore.find('[data-id="playerRating"]');
            let playerId = $rating.attr('data-player-id');

            if (!playerId) {
                $rating.removeClass('loading').empty().append(renderNotLinkedNotice());
                resolve();
                return;
            }

            Api.request('/battle/participant/rating', {
                participantId: $rating.attr('data-participant-id'),
                playerId: playerId
            }).then(function(response) {
                $rating.empty();
                if (response.rating && (response.rating.length > 0)) {
                    renderPlayerRating(response.rating, $rating);
                } else {
                    $rating.append(`<div class="text-white-50 pt-small"><i class="fa-solid fa-inbox"></i> ${__i18n('player/rating/none')}</div>`);
                }
            }).catch(error => {
                $rating.empty();
                $rating.append(`<div class="text-red pt-small">${__i18n(`error/${error.message}`)}</div>`);
                console.error(error);
            }).finally(() => {
                $rating.removeClass('loading');
                resolve();
            });
        });
    }

    function renderInforMoreContentTournaments($infoMore) {
        return new Promise(resolve => {
            let $tournaments = $infoMore.find('[data-id="playerTournaments"]');
            let playerId = $tournaments.attr('data-player-id');

            if (!playerId) {
                $tournaments.removeClass('loading').empty().append(renderNotLinkedNotice());
                resolve();
                return;
            }

            Api.request('/battle/participant/tournaments', {
                playerId: playerId
            }).then(function(response) {
                $tournaments.empty();
                if (response.tournaments && (response.tournaments.length > 0)) {
                    renderPlayerTournaments(response.tournaments, $tournaments);
                } else {
                    $tournaments.append(`<div class="text-white-50 pt-small"><i class="fa-solid fa-inbox"></i> ${__i18n('player/tournaments/none')}</div>`);
                }
            }).catch(error => {
                $tournaments.empty();
                $tournaments.append(`<span class="text-red">${__i18n(`error/${error.message}`)}</span>`);
                console.error(error);
            }).finally(() => {
                $tournaments.removeClass('loading');
                resolve();
            });
        });
    }

    _this = {
        showParticipantInfo: function(participant, buttons) {
            let details, $details, hasPrevTournament, $prevTournament;

            hasPrevTournament = participant.prevTournamentId && participant.prevTournamentPosition;

            details = renderParticipantDetails(participant, hasPrevTournament, !!participant.id);

            if (hasPrevTournament) {
                details.push([`<div>`,
                    `<h4 class="text-white mt-medium mb-small">${__i18n('player/qualifiedFrom')}</h4>`,
                    `<div class="player-prevTournament loaderSmall alignLeft loading row row-center" data-id="playerPrevTournament">`,
                    `</div>`,
                `</div>`].join(''));
            }

            details.push([`<div class="mt-medium">`,
                `<div class="player-info-more isLoading" data-player-info="rating">`,
                    `<div class="player-info-more-toggle" data-trigger-action="player.info.toggle">`,
                        `<h4 class="color-white">${__i18n('player/rating/title')}</h4>`,
                        `<i class="fa-solid fa-chevron-down"></i>`,
                    `</div>`,
                    `<div class="player-info-more-content" style="display:none;">`,
                        `<div class="player-rating-header mt-small">`,
                            `<h5 class="player-rating-game pt-tiny color-white">${__i18n('player/rating/game')}</h5>`,
                            `<h5 class="player-rating-rating pt-tiny color-white">${__i18n('player/rating/rating')}</h5>`,
                            `<h5 class="player-rating-total pt-tiny color-white">${__i18n('player/rating/count')}</h5>`,
                            `<h5 class="player-rating-quote pt-tiny color-white">${__i18n('player/rating/quote')}</h5>`,
                        `</div>`,
                        `<div class="player-ratings loaderSmall alignLeft loading" data-id="playerRating" data-participant-id="${participant.id || ''}" data-player-id="${participant.playerId || ''}">`,
                        `</div>`,
                    `</div>`,
            `</div>`].join(''));

            details.push([`<div class="mt-medium">`,
                `<div class="player-info-more isLoading" data-player-info="tournaments">`,
                    `<div class="player-info-more-toggle" data-trigger-action="player.info.toggle" data-prev-tournament-id="${participant.prevTournamentId || ''}" data-prev-tournament-id="${participant.prevTournamentId || ''}">`,
                        `<h4 class="color-white">${__i18n('player/tournaments/participations')}</h4>`,
                        `<i class="fa-solid fa-chevron-down"></i>`,
                    `</div>`,
                    `<div class="player-info-more-content" style="display:none;">`,
                        `<div class="player-tournaments loaderSmall alignLeft loading mt-small" data-id="playerTournaments" data-player-id="${participant.playerId || ''}">`,
                        `</div>`,
                    `</div>`,
            `</div>`].join(''));

            details.push([`<div class="mt-medium">`,
                `<div class="player-info-more isLoading" data-player-info="matches">`,
                    `<div class="player-info-more-toggle" data-trigger-action="player.info.toggle">`,
                        `<h4 class="color-white">${__i18n('player/matches/title')} <span class="color-white-50 text-small">${__i18n('player/matches/subtitle')}</span></h4>`,
                        `<i class="fa-solid fa-chevron-down"></i>`,
                    `</div>`,
                    `<div class="player-info-more-content" style="display:none;">`,
                        `<div class="player-matches loaderSmall alignLeft loading mt-small" data-id="playerMatches" data-player-id="${participant.playerId || ''}">`,
                        `</div>`,
                    `</div>`,
            `</div>`].join(''));

            details.push([`<div class="mt-medium">`,
                `<div class="player-info-more isLoading" data-player-info="opponents">`,
                    `<div class="player-info-more-toggle" data-trigger-action="player.info.toggle">`,
                        `<h4 class="color-white">${__i18n('player/opponents/title')}</h4>`,
                        `<i class="fa-solid fa-chevron-down"></i>`,
                    `</div>`,
                    `<div class="player-info-more-content" style="display:none;">`,
                        `<div class="player-opponents loaderSmall alignLeft loading mt-small" data-id="playerOpponents" data-player-id="${participant.playerId || ''}">`,
                        `</div>`,
                    `</div>`,
            `</div>`].join(''));

            $details = showParticipantDialog(`<i class="fa-solid fa-user"></i> ${__i18n('dialog/participant/info/title')}`, details, buttons);

            if (hasPrevTournament) {
                $prevTournament = $details.find('[data-id="playerPrevTournament"]');

                Api.request('/battle/participant/prevTournament', {
                    participantId: participant.id
                }).then(function(response) {
                    renderPrevTournament(response.prevTournament, getPrevTournamentPositionHtml(participant), $prevTournament);
                }).catch(error => {
                    $prevTournament.empty();
                    $prevTournament.append(`<span class="text-red">${__i18n(`error/${error.message}`)}</span>`);
                    console.error(error);
                }).finally(() => {
                    $prevTournament.removeClass('loading');
                })
            }
        },

        showParticipantContact: function(participant, contactData, buttons) {
            let details, hasContactData;

            details = renderParticipantDetails(participant);

            hasContactData = contactData && (Object.keys(contactData).length > 0);

            details.push([`<div class="mt-medium" data-participant-id="${participant.id}">`,
                `<a href="javascript:" data-trigger-action="participant.info:close" class="color-blue">`,
                    `<span><i class="fa-regular fa-user"></i> ${__i18n('action/info')}</span>`,
                    `<span class="text-smaller ml-tiny"><i class="fa-solid fa-chevron-right"></i></span>`,
                `</a>`,
            `</div>`].join(''));

            details.push([`<div>`,
                `<h4 class="text-white mt-medium">${__i18n('player/contactData/title')}</h4>`,
                `<a class="block mt-medium" href="${hasContactData && contactData.email ? `mailto:${contactData.email}` : 'javascript:'}" target="_blank">`,
                    `<span class="color-white-80 pr-tiny"><i class="fa-solid fa-envelope"></i></span>`,
                    `${hasContactData && contactData.email ? `<span class="color-yellow">${contactData.email}</span>` : `<span class="color-white-30">${__i18n(hasContactData ? 'form/none' : 'player/contactData/notAllowed')}</span>`}`,
                `</a>`,
                `<a class="block mt-medium" href="${hasContactData && contactData.phone ? `tel:${contactData.phone}` : 'javascript:'}" target="_blank">`,
                    `<span class="color-white-80 pr-tiny"><i class="fa-solid fa-phone"></i></span>`,
                    `${hasContactData && contactData.phone ? `<span class="color-yellow">${contactData.phone}</span>` : `<span class="color-white-30">${__i18n(hasContactData ? 'form/none' : 'player/contactData/notAllowed')}</span>`}`,
                `</a>`,
            `</div>`].join(''));

            showParticipantDialog(`<i class="fa-solid fa-envelope"></i> ${__i18n('dialog/participant/contact/title')}`, details, buttons);
        }
    };

    
    addEventListener("DOMContentLoaded", () => {
        ScoreTrekBattle.View.register('/manual', () => { return onViewRender('manual'); }, onViewLoad, onViewUpdate, onViewUnload);
        ScoreTrekBattle.View.register('/support', () => { return onViewRender('support'); }, onViewLoad, onViewUpdate, onViewUnload);
    });

    ScoreTrekBattle.Event.on('action.player.info.toggle', function() {
        let $infoMoreToggle, $infoMore, isOpen;

        $infoMoreToggle = $(this);
        $infoMore = $infoMoreToggle.closest('.player-info-more');

        isOpen = !$infoMore.hasClass('isOpen');

        $infoMore.toggleClass('isOpen', isOpen);
        $infoMore.find('.player-info-more-content')[isOpen ? 'slideDown' : 'slideUp'](300, function() {
            if (isOpen) {
                AnimationHandler.scrollIntoView($infoMoreToggle, true);
                renderInfoMoreContent($infoMore.attr('data-player-info'), $infoMore).then(() => {
                    $infoMore.removeClass('isLoading');
                    AnimationHandler.scrollIntoView($infoMoreToggle, true);
                }).catch(error => {
                    if (!error) {
                        return;
                    }
                    console.warn(error);
                });
            }
        });
    });

    return _this;
})();